export enum OrderStatusCode {
  DRAFT,
  SUBMITTED,
  UNDER_NEGOTIATION,
  ACCEPTED,
  REJECTED,
  CANCELLED,
  EXPIRED,
  PENDING,
  PROCESSING,
  COMPLETED,
  ON_HOLD,
  FAILED,
  SHIPPED,
}

export interface OrderStatusDetails {
  name: string;
  displayName: string;
  description: string;
  color: string;
}

export const OrderStatusDetails: { [key in OrderStatusCode]: OrderStatusDetails } = {
  [OrderStatusCode.DRAFT]: {
    name: 'Πρόχειρη (Draft)',
    displayName: 'Πρόχειρη',
    description: 'Η προσφορά είναι σε στάδιο επεξεργασίας και δεν έχει αποσταλεί στον πελάτη.',
    color: 'orderGrey',
  },
  [OrderStatusCode.SUBMITTED]: {
    name: 'Υποβληθείσα (Submitted)',
    displayName: 'Υποβληθείσα',
    description: 'Η προσφορά έχει υποβληθεί στον πελάτη αλλά δεν έχει ληφθεί ακόμα απόφαση.',
    color: 'orderGrey',
  },
  [OrderStatusCode.UNDER_NEGOTIATION]: {
    name: 'Υπό Διαπραγμάτευση (Under Negotiation)',
    displayName: 'Υπό Διαπραγμάτευση',
    description: 'Ο πελάτης έχει επικοινωνήσει για να διαπραγματευτεί ή να κάνει αλλαγές στην προσφορά.',
    color: 'orderYellow',
  },
  [OrderStatusCode.ACCEPTED]: {
    name: 'Αποδεκτή (Accepted)',
    displayName: 'Αποδεκτή',
    description: 'Ο πελάτης έχει αποδεχτεί την προσφορά.',
    color: 'orderGrey',
  },
  [OrderStatusCode.REJECTED]: {
    name: 'Απορριφθείσα (Rejected)',
    displayName: 'Απορριφθείσα',
    description: 'Ο πελάτης έχει απορρίψει την προσφορά.',
    color: 'orderRed',
  },
  [OrderStatusCode.CANCELLED]: {
    name: 'Ακυρωμένη (Cancelled)',
    displayName: 'Ακυρωμένη',
    description: ' Η προσφορά ακυρώθηκε από την εταιρεία ή τον πελάτη πριν ληφθεί κάποια απόφαση.',
    color: 'orderGrey',
  },
  [OrderStatusCode.EXPIRED]: {
    name: 'Ληγμένη (Expired)',
    displayName: 'Ληγμένη',
    description: 'Η προσφορά έληξε χωρίς να υπάρχει απάντηση ή ενδιαφέρον από τον πελάτη.',
    color: 'orderGrey',
  },
  [OrderStatusCode.PENDING]: {
    name: 'Σε Εκκρεμότητα (Pending)',
    displayName: 'Σε Εκκρεμότητα',
    description: 'Η παραγγελία έχει υποβληθεί, αλλά δεν έχει ακόμα διεκπεραιωθεί.',
    color: 'orderYellow',
  },
  [OrderStatusCode.PROCESSING]: {
    name: 'Σε Επεξεργασία (Processing)',
    displayName: 'Σε Επεξεργασία',
    description: 'Η παραγγελία επεξεργάζεται και είναι σε στάδιο εκτέλεσης.',
    color: 'orderYellow',
  },
  [OrderStatusCode.COMPLETED]: {
    name: 'Ολοκληρωμένη (Completed)',
    displayName: 'Ολοκληρωμένη',
    description: 'Η παραγγελία έχει διεκπεραιωθεί πλήρως.',
    color: 'orderGrey',
  },
  [OrderStatusCode.ON_HOLD]: {
    name: 'Σε Αναμονή (On Hold)',
    displayName: 'Σε Αναμονή',
    description: 'Η παραγγελία είναι σε προσωρινή αναμονή λόγω κάποιας εκκρεμότητας (π.χ. αναμονή για πληρωμή ή απόθεμα).',
    color: 'orderYellow',
  },
  [OrderStatusCode.FAILED]: {
    name: 'Αποτυχημένη (Failed)',
    displayName: 'Αποτυχημένη',
    description: 'Η παραγγελία δεν ολοκληρώθηκε επιτυχώς (π.χ. αποτυχία πληρωμής).',
    color: 'orderRed',
  },
  [OrderStatusCode.SHIPPED]: {
    name: 'Απεσταλμένη (Shipped)',
    displayName: 'Απεσταλμένη',
    description: 'Η παραγγελία έχει αποσταλεί στον πελάτη αλλά δεν έχει παραληφθεί ακόμη.',
    color: 'orderGrey',
  },
};

// Get the color for an order status by its name (enum key string)
export const getOrderStatusColor = (statusName: string | null): string => {
  if (!statusName) return 'orderGrey';

  const statusCode = OrderStatusCode[statusName as keyof typeof OrderStatusCode];
  if (statusCode !== undefined) {
    return OrderStatusDetails[statusCode].color;
  }

  return 'orderGrey';
};

// Get the display name (Greek translation) for an order status by its name (enum key string)
export const getOrderStatusDisplayName = (statusName: string | null): string => {
  if (!statusName) return '';

  const statusCode = OrderStatusCode[statusName as keyof typeof OrderStatusCode];
  if (statusCode !== undefined) {
    return OrderStatusDetails[statusCode].displayName;
  }

  return statusName;
};
